export enum DestinoNotificacao {
    CLIENTE = "CLIENTE",
    CONSUMIDOR = "CONSUMIDOR",
    SEM_LOGIN = "SEM_LOGIN",
    TODOS = "TODOS",
}

export const RotuloDestinoNotificacao: Record<DestinoNotificacao, string> = {
    [DestinoNotificacao.CLIENTE]: "Clientes",
    [DestinoNotificacao.CONSUMIDOR]: "Consumidores",
    [DestinoNotificacao.SEM_LOGIN]: "Sem login",
    [DestinoNotificacao.TODOS]: "Todos",
}
